export default {
  vipUpgrade: {
    title: 'مبارک ہو!!',
    message: 'آپ کو VIP{from} سے VIP{to} پر ترقی دی گئی ہے',
    subtitle: 'آپ کی حمایت کا شکریہ۔ آپ کی نئی سطح خصوصی\nخدمات اور خصوصی مراعات لاتی ہے۔',
    ok: 'OK'
  },
  settle: {
    loading: "Settling...",
    cannotEnterGame: "Your balance is being settled, please try again later.",
    blockedTitle: "Settling In Progress",
    blockedMsg: "Your balance is still being settled. Please wait a moment and try again."
  }
};
